// Types qu'une URL blob affiche sans exécuter de script dans l'origine du front ; html, svg, xml… se téléchargent (doc : front.shared.attach-inline).
const INLINE_SAFE = /^(application\/pdf|image\/(png|jpe?g|gif|webp|bmp|tiff)|text\/plain|video\/(mp4|webm))$/i;

// Type vide : openInNewTab le force en application/pdf, donc inerte.
export function canOpenInline(contenttype: string | null | undefined): boolean {
  const t = (contenttype ?? '').split(';')[0].trim();
  return !t || INLINE_SAFE.test(t);
}
